// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2V-0C","dragIcon":"SortableItem_dragIcon__2htF4","disabled":"SortableItem_disabled__1v6Y_"};